import { render, staticRenderFns } from "./ApprovedApplicantsTable.vue?vue&type=template&id=0783d18c&scoped=true&"
import script from "./ApprovedApplicantsTable.vue?vue&type=script&lang=ts&"
export * from "./ApprovedApplicantsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovedApplicantsTable.vue?vue&type=style&index=0&id=0783d18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783d18c",
  null
  
)

export default component.exports